<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { mloc } from "module/utils";
  import { stores } from "module/store/SettingsStore";
  import { ModuleSetting } from "module/store/ModuleSettings";
  import type { SearchFilter } from "module/store/Filters";

  const dispatch = createEventDispatcher();

  let {
    quickEditable = true,
    filterEditorOpen = false,
    showHelp = true,
    filter,
    value = "",
  }: {
    quickEditable?: boolean;
    filterEditorOpen?: boolean;
    showHelp?: boolean;
    filter?: SearchFilter;
    value?: string;
  } = $props();

  let selectedFilterTag = $derived(filter?.tag);
  let quickEditEnabled = $derived(stores[ModuleSetting.QUICK_FILTER_EDIT]);

  function onKeydown(event: KeyboardEvent) {
    if (event.key === "Backspace" && !value) {
      dispatch("clearFilter");
    }
    if (event.key === "ArrowUp") {
      event.preventDefault();
      dispatch("navigateUp");
    }
    if (event.key === "ArrowDown") {
      event.preventDefault();
      dispatch("navigateDown");
    }
    if (event.key === "Tab") {
      event.preventDefault();
      dispatch("switchAction", { shiftKey: event.shiftKey });
    }
    if (event.key === "Enter") {
      event.preventDefault();
      dispatch("submitInput", { shiftKey: event.shiftKey });
    }
    if (event.key === "Escape") {
      event.preventDefault();
      event.stopPropagation();
      dispatch("close");
    }
  }

  function inputChanged() {
    dispatch("inputChanged", value);
  }
</script>

<div class="search-editable-input">
  {#if selectedFilterTag}
    <span
      class="search-tag"
      class:filter-opened={filterEditorOpen}
      title="@{selectedFilterTag} - {filter?.subTitle}"
    >
      @{selectedFilterTag}<!-- <i class="fas fa-times" /> -->
    </span>
  {/if}
  <input
    placeholder={showHelp ? mloc("SearchHelpHint") : ""}
    aria-haspopup="listbox"
    type="text"
    bind:value
    spellcheck="false"
    on:keydown={onKeydown}
    on:input={inputChanged}
    on:blur
    on:focus
  />
  {#if $quickEditEnabled && quickEditable}
    <i
      title={mloc("FilterPopupTitle")}
      class="fas fa-filter edit-filter"
      on:click={() => dispatch("openFilterEditor")}
    ></i>
  {/if}
</div>

<style>
  .search-editable-input {
    white-space: nowrap;
    height: var(--input-height);
    display: flex;
    align-items: center;
    flex-shrink: 0;
    cursor: auto;
    pointer-events: all;
  }

  input[type="text"] {
    padding: 0 0.2em;
    border: none;
    box-shadow: none;
    background: none;
    width: auto;
    flex-grow: 1;
    outline: none;
    font-size: inherit;
    height: 100%;
  }
  input[type="text"]:focus {
    outline: none;
  }
  .search-tag {
    position: relative;
    background: var(--qiFilterAccent);
    color: #f0f0e0;
    display: flex;
    padding: 0 0.3em;
    border-radius: 0.25em;
    max-width: 60%;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 3px;
    height: 1.8em;
    align-items: center;
  }

  .search-tag.filter-opened {
    outline: 1px solid #0003;
  }

  .edit-filter {
    margin-right: 0.5em;
  }
</style>
